export enum NotificationsSortFieldEnum {
    CODE = 'code',
    GROUP = 'groups'
  }